import {inject} from '@angular/core';
import {HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ToastService} from '../toast/toast.service';
import {AuthService} from '../../services/auth.service';

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const router = inject(Router);
  const toast = inject(ToastService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: any) => {

      // Http Error
      if (error instanceof HttpErrorResponse) {

        // No internet connection
        if (error.status === 0) {
          toast.failure("No internet connection. Please check your internet connection and try again.")
          throw error;
        }

        // Bypass default error handling
        const skipErrorInterceptor = req.context.get(SKIP_ERROR_INTERCEPTOR)
        if (!skipErrorInterceptor) {

          // Not authorized
          if (error.status === 403) {

            // Logging out to ensure that token isn't re-used
            authService.logout()

            router.navigate([`/login`]).then()
            throw error;
          }

          // Not found
          if (error.status === 404) {
            router.navigate(['/404']).then()
            throw error;
          }

          // API error response
          if (error['error']['error']['message']) {
            toast.failure(error['error']['error']['message'])
            throw error;
          }
        }
      }

      throw error
    })
  );
}
